<template>
  <div>
    <div class="Banner">
      <img src="../../assets/wlwyypt_banner.png" alt="">
    </div>
    <div class="container">
      <div class="title">
        <h1>
          物联网应用平台
        </h1>
        <aside>
          Internet of Things Application Platform
        </aside>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <p>
            悦享互联为制造业、物流运输、医疗设备等行业客户提供基于物联网技术的行业云解决方案。物联网行业应用具备终端设备分布范围广，地域跨度大的特点。
          </p>
          <p>
            医疗物联网设备分布在全国的三级、二级医院，部分产品销售到东南亚和欧美。
          </p>
          <p>
            运输管理系统的物联网设备则位置跨度上千公里。这种场景下如果对实时计算实时控制有较高的要求，因为数据回传有网络延迟，更适合在靠近用户侧的进行运算。大多数物联网设备需要对设备端收集的数据/信息加快计算，不过由于业务逻辑是独立的，需要更多的计算能力，因此常常建议将逻辑放在边缘，而不是放在设备端。它需要一条具有高可用性的反馈环路，以便物联网设备请求边缘执行某些计算，并利用结果加快处理。
          </p>
        </div>
        <div class="col-sm-8">
          <img src="../../assets/Application_platform_pic01.jpg" alt="">
        </div>
        <div class="col-sm-4">
          <img src="../../assets/Application_platform_pic02.jpg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <Footer />
  </div>
</template>

<script>
  import Footer from '../../components/Footer'
  export default {
    name: 'Introduction',
    components: {
      Footer
    },
    props: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  img{
    width: 100%;
  }
  .Banner {
    margin-bottom: 4rem;
  }
  h1 {
    font-size: 4.6rem;
    color: #fe9901;
  }
  aside {
    font-size: 1.6rem;
    color: #999;
    text-transform: uppercase;
  }
  .title {
    padding-left: 30px;
    border-left: 1px solid #ccc;
    margin-bottom: 4rem;
  }
  p {
    color: #333;
    font-size: 1.8rem;
    line-height: 35px;
    margin-bottom: 30px;
    text-indent: 30px;
  }
  .row>div {
    margin-bottom: 30px;
  }
</style>
